import { render } from "./ManageInstances.vue?vue&type=template&id=8b1d5e44&scoped=true"
import script from "./ManageInstances.vue?vue&type=script&lang=js"
export * from "./ManageInstances.vue?vue&type=script&lang=js"

import "./ManageInstances.vue?vue&type=style&index=0&id=8b1d5e44&scoped=true&lang=less"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1d5e44"]])

export default __exports__